import Store from '@/store'
import Session from '@/store/session'

export function usePlannerImported() {
  const imported = Store.useSelector((state) => state.imported)
  const user = Session.useSelector((state) => state.user)
  if (imported && imported.modified !== 'heavy') {
    return imported
  } else if (user && imported?.user?.id === user.id) {
    return imported
  }
}

export function useEditPlanner() {
  const imported = usePlannerImported()
  const user = Session.useSelector((state) => state.user)
  return !imported || !imported.user || imported.user.id === user?.id
}
